import SwitchCustom from 'components/SwitchCustom';
import styled from 'styled-components';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};
const OnHoldToggle = ({ value, onChange }: Props) => {
  const handleChange = (value: boolean) => {
    onChange?.(value);
  };
  return (
    <Container>
      <Title>
        <p className='label'>On Hold</p>
        <p className='description'>Temporarily hold the booking and reassign staff later.</p>
      </Title>
      <SwitchCustom className='switch-on-hold'
        checkedChildren={'ON'}
        unCheckedChildren={'OFF'}
        checked={value}
        onChange={handleChange}
      />
    </Container>
  );
};

export default OnHoldToggle;

const Container = styled.label`
display: flex;
padding: 4px 12px;
align-items: center;
gap: 24px;
align-self: stretch;
border-radius: 8px;
border: 2px dashed red;
background: #FFF;
margin: 16px;
margin-top: 0;
&:active {
  background: #eee;
}
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */

&:hover {
  cursor: pointer;
}

.switch-on-hold {
  zoom: 1.2;
}
`;

const Title = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 2px;
flex: 1 0 0;
p {
  align-self: stretch;
  text-align: left;
}
p.label {
  color: red;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
p.description {
  color: #505050;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
`;